import styled from 'styled-components'

import { Table, TableProps } from '../Table'
import { themeFontSize } from '../theme'

const SmallTextTable = <RecordType extends object = any>(T: typeof Table) => styled(
  (props: TableProps<RecordType> & { className?: string }) => {
    return <T {...props} />
  }
)`
  .ant-table-cell {
    font-size: ${themeFontSize('extraSmall')};
  }
`

export const GetTypedSmallTextTable = <T extends object = any>() => SmallTextTable<T>(Table)
